export const SECTION_CONFIG = {
  assets: {
    titleKey: 'Assets accounts',
    modalTitleKey: 'Add {{finInstName}} Assets',
    emptyTextKey: 'You have no assets yet.',
    actionTextKey: 'Add assets',
    itemTitleKey: 'Asset {{index}}',
    fields: [
      { labelKey: 'Account type', valueKey: 'accountType' },
      { labelKey: 'Account Number', valueKey: 'account' },
      { labelKey: 'Remarks', valueKey: 'remarks' },
    ],
  },
  liabilities: {
    titleKey: 'Liabilities accounts',
    modalTitleKey: 'Add {{finInstName}} Liabilities',
    emptyTextKey: 'You have no liabilities yet.',
    actionTextKey: 'Add liabilities',
    itemTitleKey: 'Liability {{index}}',
    fields: [
      { labelKey: 'Liability type', valueKey: 'liabilityType' },
      { labelKey: 'Account Number', valueKey: 'account' },
      { labelKey: 'Remarks', valueKey: 'remarks' },
    ],
  },
  creditCards: {
    titleKey: 'Credit cards',
    modalTitleKey: 'Add {{finInstName}} Credit Cards',
    emptyTextKey: 'You have no credit cards yet.',
    actionTextKey: 'Add Credit Cards',
    itemTitleKey: 'Card {{index}}',
    fields: [
      { labelKey: 'Credit Card / Issuer Name', valueKey: 'name' },
      { labelKey: 'Number', valueKey: 'number' },
      { labelKey: 'Remarks', valueKey: 'remarks' },
    ],
  },
};
